const nbfcKYC = 'https://staging.api.edgrofin.com/api-gateway-edgrofin/private';
const documents = 'https://staging.api.edgrofin.com/kyc-stack/private';
const propelld = 'http://localhost:5001';

const baseUrls = {
    documents,
    nbfcKYC,
    propelld
};

export default baseUrls;
